export const siteIntegers = [];
export const siteFloats = [];
export const siteIsoStrings = [];
export const siteWhiteList = ['id', 'name', 'projectNumber'];
export const siteOptimisticList = ['siteLocations', ...siteWhiteList];
